var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64999 17.7627L1.17132 15.5714C0.969346 15.4905 0.790221 15.3615 0.649571 15.1955C0.508921 15.0296 0.411019 14.8317 0.364403 14.6192C0.317788 14.4067 0.323877 14.186 0.382139 13.9764C0.4404 13.7668 0.549064 13.5747 0.698652 13.4167L12.6987 0.750049C13.6887 -0.295284 15.4033 0.753382 14.924 2.11005L11.35 12.2367L16.8287 14.4287C17.0306 14.5096 17.2097 14.6386 17.3504 14.8046C17.491 14.9705 17.589 15.1684 17.6356 15.3809C17.6822 15.5934 17.6761 15.8141 17.6178 16.0237C17.5596 16.2333 17.4509 16.4254 17.3013 16.5834L5.30132 29.25C4.31132 30.2954 2.59665 29.2467 3.07598 27.89L6.64999 17.7634V17.7627ZM3.98532 13.8247L8.82865 15.762C9.14819 15.8899 9.40592 16.1363 9.54795 16.4498C9.68996 16.7633 9.70527 17.1195 9.59065 17.444L7.67732 22.8647L14.0147 16.1754L9.17132 14.238C8.85178 14.1102 8.59404 13.8638 8.45203 13.5503C8.31001 13.2368 8.2947 12.8806 8.40932 12.556L10.3227 7.13538L3.98532 13.8247Z",
    fill: "#C3C7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1ba179ea3fcc9a822cafd615cb69f3d3.svg";
export { ForwardRef as ReactComponent };